<template>
  <validation-provider
    #default="{ errors }"
    :name="label"
    :vid="label"
    :rules="rules"
  >
    <b-form-group
      :label="label"
      :label-for="name"
      :class="{'disabled': readonly || disabled}"
    >
      <v-select
        ref="select"
        key="value"
        v-model="inputValue"
        :name="name"
        :options="options"
        v-bind="$attrs"
        :placeholder="placeholder"
        append-to-body
        label="text"
        :multiple="multiple"
        :state="errors.length > 0 ? false:null"
        :disabled="disabled"
        @change="onChange"
        @open="onOpen"
      >
        <div slot="no-options">
          Nenhum(a) {{ label }} encontrado(a).
        </div>
      </v-select>
      <small class="text-danger">{{ errors[0] }}</small>
      <item-help v-if="help" :help="help" class="float-right position-relative l-0"/>
    </b-form-group>

  </validation-provider>

</template>

<script>

import { ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import ItemHelp from "@/components/i2/forms/elements/ItemHelp.vue";

export default {
  name: 'I2FormVueSelect',
  components: {
    ItemHelp,
    ValidationProvider,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: [String, Number, Object, Array],
      default: '',
    },
    name: {
      type: String,
      required: true,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    options: {
      type: Array,
      required: true,
    },
    rules: {
      type: String,
      default: '',
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    help: {
      type: String,
      default: '',
      required: false,
    },

    valueField: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  data() {
    return {
      inputValue: '',
      selected: null,
      required,
    }
  },
  mounted() {
    this.inputValue = this.value
  },
  watch: {
    value(data) {
      this.inputValue = data
    },
    inputValue(val) {
      if (this.valueField) {
        this.$emit('input', val?.value || null)
        this.$emit('onChange', val?.value || null)
      }
      this.$emit('input', val)
      this.$emit('onChange', val)
    },
  },
  methods: {
    onChange(data) {
      this.$emit('onChange', data)
    },
    onOpen() {
      setTimeout(() => {
        // Acesse o dropdown diretamente com o ref e modifique o estilo
        const dropdownMenu = this.$refs.select.$el.querySelector('.vs__dropdown-menu')
        if (dropdownMenu) {
          this.zIndex =  50000
          dropdownMenu.style.zIndex = '500000 !important';  // Ajuste o z-index
          dropdownMenu.style.borderColor = 'red !important';  // Ajuste o z-index
          dropdownMenu.style.position = 'absolute !important';  // Ajuste o z-index
        }
      }, 200)
    },
  },
}
</script>
<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
.vs__dropdown-menu {
  z-index: 9999999 !important;
  border-color: red !important;
}
</style>
